(function () {
  'use strict';

  var SC = {
    init: function () {
      this.initStickyATC();
      this.initFAQ();
      this.initPDPTabs();
      this.initPDPDescExpand();
      this.initPDPReviewsExpand();
      this.initGoogleReviews();
      this.initJDGMReviewSort();
      this.initFBT();
      this.initPDPGallerySticky();
      this.initPDPGallery();
      this.initPDPSizeChart();
      this.initSmoothScroll();
      this.initScrollTop();
    },

    initStickyATC: function () {
      var bar = document.querySelector('.sc-sticky-atc');
      if (!bar) return;

      var mainBtn = document.querySelector('.product-single__form .add-to-cart');
      var stickyBtn = bar.querySelector('.sc-sticky-atc__btn');
      var priceEl = bar.querySelector('.sc-sticky-atc__price');
      var mainPrice = document.querySelector('[id^="ProductPrice-"]');

      if (stickyBtn && mainBtn) {
        stickyBtn.addEventListener('click', function () {
          if (!mainBtn.disabled) {
            mainBtn.click();
          }
        });

        var syncBtn = function () {
          stickyBtn.disabled = mainBtn.disabled;
          stickyBtn.textContent = mainBtn.textContent.trim();
        };

        syncBtn();

        var observer = new MutationObserver(syncBtn);
        observer.observe(mainBtn, { attributes: true, childList: true, subtree: true });
      }

      if (priceEl && mainPrice) {
        var syncPrice = function () {
          priceEl.textContent = mainPrice.textContent.trim();
        };
        syncPrice();
        var priceObserver = new MutationObserver(syncPrice);
        priceObserver.observe(mainPrice, { childList: true, subtree: true, characterData: true });
      }

      if (!mainBtn) return;

      var toggle = function () {
        var rect = mainBtn.getBoundingClientRect();
        var show = rect.bottom < 0 || rect.top > window.innerHeight;
        bar.classList.toggle('is-visible', show);
      };

      window.addEventListener('scroll', toggle, { passive: true });
      toggle();
    },

    initFAQ: function () {
      document.querySelectorAll('.sc-faq__question').forEach(function (btn) {
        if (btn.dataset.scBound) return;
        btn.dataset.scBound = 'true';
        btn.addEventListener('click', function () {
          var item = btn.closest('.sc-faq__item');
          var isOpen = item.classList.contains('is-open');

          item.closest('.sc-faq__list').querySelectorAll('.sc-faq__item.is-open').forEach(function (openItem) {
            if (openItem !== item) {
              openItem.classList.remove('is-open');
              openItem.querySelector('.sc-faq__question').setAttribute('aria-expanded', 'false');
            }
          });

          item.classList.toggle('is-open', !isOpen);
          btn.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
        });
      });
    },

    initPDPTabs: function () {
      document.querySelectorAll('.sc-pdp-tabs').forEach(function (tabs) {
        if (tabs.dataset.scBound) return;
        tabs.dataset.scBound = 'true';

        var tabBtns = tabs.querySelectorAll('.sc-pdp-tabs__tab');
        var panels = tabs.querySelectorAll('.sc-pdp-tabs__panel');

        tabBtns.forEach(function (btn) {
          btn.addEventListener('click', function () {
            var target = btn.getAttribute('data-sc-pdp-tab');

            tabBtns.forEach(function (t) {
              var active = t === btn;
              t.classList.toggle('is-active', active);
              t.setAttribute('aria-selected', active ? 'true' : 'false');
            });

            panels.forEach(function (panel) {
              var active = panel.getAttribute('data-sc-pdp-panel') === target;
              panel.classList.toggle('is-active', active);
              if (active) {
                panel.removeAttribute('hidden');
              } else {
                panel.setAttribute('hidden', '');
              }
            });
          });
        });
      });
    },

    initPDPDescExpand: function () {
      document.querySelectorAll('[data-sc-desc-expand]').forEach(function (wrap) {
        if (wrap.dataset.scBound) return;
        wrap.dataset.scBound = 'true';

        var body = wrap.querySelector('.sc-pdp-desc-expand__body');
        var btn = wrap.querySelector('.sc-pdp-desc-expand__toggle');
        var label = wrap.querySelector('.sc-pdp-desc-expand__toggle-text');
        if (!body || !btn) return;

        var measureTimer;

        var getCollapsed = function () {
          return parseInt(getComputedStyle(wrap).getPropertyValue('--sc-desc-collapsed'), 10) || 180;
        };

        var measureFullHeight = function () {
          var wasExpanded = wrap.classList.contains('is-expanded');
          if (wasExpanded) {
            wrap.classList.remove('is-expanded');
          }

          body.style.maxHeight = 'none';
          var fullHeight = body.scrollHeight;
          body.style.maxHeight = '';
          wrap.style.setProperty('--sc-desc-full-height', fullHeight + 'px');
          wrap.classList.toggle('is-short', fullHeight <= getCollapsed() + 16);

          if (wasExpanded) {
            wrap.classList.add('is-expanded');
          }

          return fullHeight;
        };

        var scheduleMeasure = function () {
          clearTimeout(measureTimer);
          measureTimer = setTimeout(function () {
            if (!wrap.classList.contains('is-expanded')) {
              measureFullHeight();
            }
          }, 100);
        };

        measureFullHeight();
        window.addEventListener('resize', scheduleMeasure);
        window.addEventListener('load', scheduleMeasure);

        btn.addEventListener('click', function () {
          var isExpanded = wrap.classList.contains('is-expanded');

          if (isExpanded) {
            var collapsedPx = getCollapsed() + 'px';
            var fullPx = wrap.style.getPropertyValue('--sc-desc-full-height') || (measureFullHeight() + 'px');
            var scrollY = window.pageYOffset;
            var fullHeight = body.scrollHeight;
            var heightLost = Math.max(0, fullHeight - getCollapsed());

            wrap.classList.remove('is-expanded');
            btn.setAttribute('aria-expanded', 'false');
            if (label) {
              label.textContent = 'Read full description';
            }

            body.style.maxHeight = fullPx;
            body.offsetHeight;
            body.style.maxHeight = collapsedPx;

            body.addEventListener('transitionend', function onEnd(e) {
              if (e.target !== body || e.propertyName !== 'max-height') return;
              body.removeEventListener('transitionend', onEnd);
              body.style.maxHeight = '';
              window.scrollTo(0, scrollY - heightLost);
            });
          } else {
            var fullHeight = measureFullHeight();
            wrap.classList.add('is-expanded');
            btn.setAttribute('aria-expanded', 'true');
            if (label) {
              label.textContent = 'Show less';
            }

            body.style.maxHeight = getCollapsed() + 'px';
            body.offsetHeight;
            body.style.maxHeight = fullHeight + 'px';

            body.addEventListener('transitionend', function onEnd(e) {
              if (e.target !== body || e.propertyName !== 'max-height') return;
              body.removeEventListener('transitionend', onEnd);
              body.style.maxHeight = '';
            });
          }
        });
      });
    },

    initPDPReviewsExpand: function () {
      document.querySelectorAll('[data-sc-reviews-expand]').forEach(function (wrap) {
        if (wrap.dataset.scBound) return;
        wrap.dataset.scBound = 'true';

        var body = wrap.querySelector('.sc-pdp-reviews-expand__body');
        var btn = wrap.querySelector('.sc-pdp-reviews-expand__toggle');
        var label = wrap.querySelector('.sc-pdp-reviews-expand__toggle-text');
        var widget = wrap.querySelector('.jdgm-review-widget, #judgeme_product_reviews');
        if (!body || !btn) return;

        var measureTimer;

        var measure = function () {
          if (wrap.classList.contains('is-expanded')) return;

          body.style.maxHeight = 'none';
          var fullHeight = body.scrollHeight;
          body.style.maxHeight = '';
          wrap.style.setProperty('--sc-reviews-full-height', fullHeight + 'px');

          var collapsed = parseInt(getComputedStyle(wrap).getPropertyValue('--sc-reviews-collapsed'), 10) || 320;
          wrap.classList.toggle('is-short', fullHeight <= collapsed + 16);
        };

        var scheduleMeasure = function () {
          clearTimeout(measureTimer);
          measureTimer = setTimeout(measure, 200);
        };

        measure();
        window.addEventListener('resize', scheduleMeasure);
        window.addEventListener('load', scheduleMeasure);

        if (widget && typeof MutationObserver !== 'undefined') {
          var observer = new MutationObserver(scheduleMeasure);
          observer.observe(widget, { childList: true, subtree: true });
        }

        setTimeout(scheduleMeasure, 800);
        setTimeout(scheduleMeasure, 2000);

        btn.addEventListener('click', function () {
          var expanded = wrap.classList.toggle('is-expanded');
          btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          if (label) {
            label.textContent = expanded ? 'Show less reviews' : 'Read all reviews';
          }
          if (!expanded) {
            body.style.maxHeight = '';
            scheduleMeasure();
          }
        });
      });
    },

    initJDGMReviewSort: function () {
      var getReviewScore = function (review) {
        var ratingEl = review.querySelector('.jdgm-rev__rating');
        if (ratingEl) {
          var score = parseFloat(ratingEl.getAttribute('data-score'));
          if (!isNaN(score)) return score;
        }

        var onStars = review.querySelectorAll('.jdgm-star.jdgm--on');
        if (onStars.length) return onStars.length;

        return 0;
      };

      var getReviewTime = function (review) {
        var ts = review.querySelector('.jdgm-rev__timestamp');
        if (!ts) return 0;
        var raw = ts.getAttribute('data-content') || ts.getAttribute('datetime') || ts.textContent;
        var parsed = Date.parse(raw);
        return isNaN(parsed) ? 0 : parsed;
      };

      var isPinned = function (review) {
        return review.classList.contains('jdgm-rev--pinned') ||
          review.classList.contains('jdgm-rev--featured') ||
          review.getAttribute('data-pinned') === 'true';
      };

      var triggerNativeSort = function (widget) {
        if (widget.dataset.scNativeSortTried) return;

        var sortTriggers = [
          '[data-value="highest_rating"]',
          '[data-value="rating-desc"]',
          '[data-value="rating"]',
          '[data-sort-value="rating"]'
        ];

        var i;
        for (i = 0; i < sortTriggers.length; i++) {
          var nativeOption = widget.querySelector(sortTriggers[i]);
          if (nativeOption) {
            widget.dataset.scNativeSortTried = 'true';
            nativeOption.click();
            return;
          }
        }

        var options = widget.querySelectorAll('.jdgm-sort-dropdown__option, [role="option"], .jdgm-sort-dropdown option');
        for (i = 0; i < options.length; i++) {
          var label = (options[i].textContent || '').toLowerCase();
          if (label.indexOf('highest') !== -1 || label.indexOf('high rating') !== -1 || label.indexOf('top rated') !== -1) {
            widget.dataset.scNativeSortTried = 'true';
            options[i].click();
            return;
          }
        }
      };

      var sortWidget = function (widget) {
        if (widget.dataset.scSorting === 'true') return;

        triggerNativeSort(widget);

        var list = widget.querySelector('.jdgm-rev-widg__reviews') ||
          widget.querySelector('.jdgm-rev-widg') ||
          widget.querySelector('.jdgm-reviews-list');

        if (!list) return;

        var reviews = Array.prototype.filter.call(list.children, function (el) {
          return el.classList && el.classList.contains('jdgm-rev');
        });

        if (reviews.length < 2) {
          reviews = Array.prototype.slice.call(list.querySelectorAll('.jdgm-rev'));
        }

        if (reviews.length < 2) return;

        var pinned = [];
        var regular = [];

        reviews.forEach(function (review) {
          if (isPinned(review)) {
            pinned.push(review);
          } else {
            regular.push(review);
          }
        });

        regular.sort(function (a, b) {
          var scoreDiff = getReviewScore(b) - getReviewScore(a);
          if (scoreDiff !== 0) return scoreDiff;
          return getReviewTime(b) - getReviewTime(a);
        });

        var ordered = pinned.concat(regular);
        var orderKey = ordered.map(function (review) {
          return review.getAttribute('data-review-id') || review.id || getReviewScore(review);
        }).join('|');

        if (widget.dataset.scReviewOrder === orderKey) return;

        widget.dataset.scSorting = 'true';
        ordered.forEach(function (review) {
          list.appendChild(review);
        });
        widget.dataset.scReviewOrder = orderKey;
        delete widget.dataset.scSorting;
      };

      var bindWidget = function (widget) {
        if (widget.dataset.scReviewSortBound) return;
        widget.dataset.scReviewSortBound = 'true';

        var debounce;
        var run = function () {
          clearTimeout(debounce);
          debounce = setTimeout(function () {
            sortWidget(widget);
          }, 250);
        };

        run();
        window.addEventListener('load', run);
        setTimeout(run, 1000);
        setTimeout(run, 3000);

        if (typeof MutationObserver !== 'undefined') {
          var observer = new MutationObserver(run);
          observer.observe(widget, { childList: true, subtree: true });
        }
      };

      document.querySelectorAll('#judgeme_product_reviews, .jdgm-review-widget').forEach(bindWidget);
    },

    initGoogleReviews: function () {
      var avatarColors = ['#178DF1', '#0d9488', '#7c3aed', '#db2777', '#ea580c', '#2563eb', '#059669'];

      var colorFromName = function (name) {
        var hash = 0;
        var str = String(name || 'C');
        for (var i = 0; i < str.length; i++) {
          hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        return avatarColors[Math.abs(hash) % avatarColors.length];
      };

      var starsHtml = function (rating) {
        var html = '';
        for (var i = 1; i <= 5; i++) {
          html += '<span class="sc-greview-card__star' + (i > rating ? ' sc-greview-card__star--empty' : '') + '" aria-hidden="true">★</span>';
        }
        return html;
      };

      var formatRelativeDate = function (dateStr) {
        if (!dateStr || dateStr.indexOf('/') === -1) return dateStr || '';
        var parts = dateStr.split('/');
        var d = new Date(parts[2], parts[0] - 1, parts[1]);
        if (isNaN(d.getTime())) return dateStr;
        var days = Math.floor((Date.now() - d.getTime()) / 86400000);
        if (days < 7) return days <= 1 ? 'Yesterday' : days + ' days ago';
        if (days < 30) return Math.floor(days / 7) + ' weeks ago';
        if (days < 365) return Math.floor(days / 30) + ' months ago';
        return Math.floor(days / 365) + ' years ago';
      };

      var renderCard = function (review) {
        var esc = function (s) {
          return String(s || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
        };

        var name = review.customer || review.author || 'Customer';
        var initial = name.charAt(0).toUpperCase();
        var rating = Math.max(0, Math.min(5, parseInt(review.rating, 10) || 5));
        var text = review.title || review.text || review.quote || '';
        var date = formatRelativeDate(review.date);
        var product = review.product || '';
        var verified = review.verified !== false;

        return (
          '<article class="sc-greview-card">' +
            '<header class="sc-greview-card__head">' +
              '<div class="sc-greview-card__avatar" style="background:' + colorFromName(name) + '">' + esc(initial) + '</div>' +
              '<div class="sc-greview-card__meta">' +
                '<div class="sc-greview-card__name-row">' +
                  '<strong class="sc-greview-card__name">' + esc(name) + '</strong>' +
                  (verified ? '<span class="sc-greview-card__verified"><svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>Verified</span>' : '') +
                '</div>' +
                (date ? '<time class="sc-greview-card__date">' + esc(date) + '</time>' : '') +
              '</div>' +
              '<div class="sc-greview-card__stars" aria-label="' + rating + ' out of 5 stars">' + starsHtml(rating) + '</div>' +
            '</header>' +
            (text ? '<p class="sc-greview-card__text">' + esc(text) + '</p>' : '') +
            (product ? '<p class="sc-greview-card__product">' + esc(product) + '</p>' : '') +
          '</article>'
        );
      };

      var paintAvatars = function (root) {
        root.querySelectorAll('.sc-greview-card__avatar[data-sc-initial]').forEach(function (el) {
          var initial = el.getAttribute('data-sc-initial') || 'C';
          el.style.background = colorFromName(initial);
        });
      };

      document.querySelectorAll('[data-sc-greviews]').forEach(function (section) {
        paintAvatars(section);

        var apiUrl = section.getAttribute('data-api-url');
        var list = section.querySelector('[data-sc-greviews-list]');
        var ratingEl = section.querySelector('[data-sc-greviews-rating]');
        var countEl = section.querySelector('[data-sc-greviews-count]');
        var productFilter = (section.getAttribute('data-product-title') || '').toLowerCase().trim();
        var maxReviews = parseInt(section.getAttribute('data-max-reviews'), 10) || 8;

        if (!apiUrl || !list) {
          paintAvatars(section);
          return;
        }

        fetch(apiUrl, { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (!data.ok || !data.reviews || !data.reviews.length) return;

            var reviews = data.reviews;
            if (productFilter) {
              reviews = reviews.filter(function (r) {
                return (r.product || '').toLowerCase().indexOf(productFilter) !== -1;
              });
            }

            if (!reviews.length) {
              list.innerHTML = '<p class="sc-greviews__loading">No reviews for this product yet.</p>';
              return;
            }

            reviews = reviews.slice(0, maxReviews);
            list.innerHTML = reviews.map(renderCard).join('');
            paintAvatars(section);

            if (data.summary) {
              if (ratingEl && data.summary.average) {
                ratingEl.textContent = data.summary.average.toFixed(1);
              }
              if (countEl && data.summary.count) {
                countEl.textContent = data.summary.count;
              }
            }

            section.classList.add('is-live');
          })
          .catch(function () {
            var loading = list.querySelector('.sc-greviews__loading');
            if (loading) {
              loading.textContent = 'Reviews will appear here once connected.';
            }
          });
      });
    },

    initFBT: function () {
      document.querySelectorAll('[data-sc-fbt]').forEach(function (bundle) {
        if (bundle.dataset.scBound) return;
        bundle.dataset.scBound = 'true';

        var totalEl = bundle.querySelector('[data-sc-fbt-total]');
        var addBtn = bundle.querySelector('[data-sc-fbt-add-all]');
        var statusEl = bundle.querySelector('[data-sc-fbt-status]');
        var items = bundle.querySelectorAll('[data-sc-fbt-item]');

        var formatMoney = function (cents) {
          if (window.Shopify && typeof Shopify.formatMoney === 'function') {
            return Shopify.formatMoney(cents, theme.moneyFormat || '${{amount}}');
          }
          return '$' + (cents / 100).toFixed(2);
        };

        var updateTotal = function () {
          var total = 0;
          items.forEach(function (item) {
            var check = item.querySelector('.sc-fbt__check');
            if (check && check.checked && !check.disabled) {
              total += parseInt(item.getAttribute('data-price'), 10) || 0;
            }
          });
          if (totalEl) totalEl.textContent = formatMoney(total);

          if (addBtn) {
            var anyChecked = Array.prototype.some.call(items, function (item) {
              var check = item.querySelector('.sc-fbt__check');
              return check && check.checked && !check.disabled;
            });
            addBtn.disabled = !anyChecked;
          }
        };

        items.forEach(function (item) {
          var check = item.querySelector('.sc-fbt__check');
          if (check) check.addEventListener('change', updateTotal);
        });

        updateTotal();

        if (!addBtn) return;

        addBtn.addEventListener('click', function () {
          var selected = [];
          items.forEach(function (item) {
            var check = item.querySelector('.sc-fbt__check');
            if (check && check.checked && !check.disabled) {
              selected.push({
                id: parseInt(item.getAttribute('data-variant-id'), 10),
                quantity: 1
              });
            }
          });

          if (!selected.length) return;

          addBtn.classList.add('is-loading');
          addBtn.textContent = 'Adding…';
          if (statusEl) {
            statusEl.textContent = '';
            statusEl.classList.remove('is-error');
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: selected })
          })
            .then(function (res) {
              if (!res.ok) throw new Error('Add failed');
              return res.json();
            })
            .then(function () {
              if (statusEl) statusEl.textContent = 'Added to cart!';
              addBtn.textContent = 'Added — View cart';
              window.location.href = '/cart';
            })
            .catch(function () {
              if (statusEl) {
                statusEl.textContent = 'Could not add items. Please try again.';
                statusEl.classList.add('is-error');
              }
              addBtn.textContent = 'Add selected to cart';
            })
            .finally(function () {
              addBtn.classList.remove('is-loading');
            });
        });
      });
    },

    initPDPGallerySticky: function () {
      if (!document.body.classList.contains('template-product')) return;

      var updateTop = function () {
        var header = document.querySelector('.site-header');
        var announcement = document.querySelector('.announcement-bar');
        var headerH = header ? header.offsetHeight : 80;
        var announceH = announcement ? announcement.offsetHeight : 0;
        document.documentElement.style.setProperty('--sc-pdp-sticky-top', (headerH + announceH + 16) + 'px');
      };

      if (document.documentElement.dataset.scPdpStickyTop) return;
      document.documentElement.dataset.scPdpStickyTop = 'true';

      updateTop();
      window.addEventListener('resize', updateTop);
      window.addEventListener('load', updateTop);
    },

    initPDPGallery: function () {
      if (!document.body.classList.contains('template-product')) return;
      if (document.documentElement.dataset.scPdpGalleryBound) return;
      document.documentElement.dataset.scPdpGalleryBound = 'true';

      var unveilImages = function (root) {
        var scope = root || document;
        scope.querySelectorAll('.product__main-photos img.lazyload, .product__thumbs img.lazyload').forEach(function (img) {
          if (window.lazySizes && lazySizes.loader) {
            lazySizes.loader.unveil(img);
          }
        });
      };

      var syncActiveThumb = function ($main, index) {
        if (typeof jQuery === 'undefined' || !$main || !$main.length) return;
        var sectionId = $main.attr('id').replace('ProductPhotos-', '');
        var $thumbs = jQuery('#ProductThumbs-' + sectionId);
        var $active = $thumbs.find('.product__thumb-item[data-index="' + index + '"]');
        $thumbs.find('.product__thumb-item').removeClass('slick-current is-active');
        $active.addClass('slick-current is-active');
        if ($active.length && $thumbs.hasClass('sc-pdp__thumbs--all')) {
          $active[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      };

      var switchMainImage = function ($main, index) {
        if (!$main || !$main.length || isNaN(index)) return;

        if ($main.hasClass('slick-initialized')) {
          $main.slick('slickGoTo', index);
          return;
        }

        $main.children('[data-index]').each(function () {
          var $slide = jQuery(this);
          var slideIndex = parseInt($slide.attr('data-index'), 10);
          if (slideIndex === index) {
            $slide.show().addClass('starting-slide').removeClass('secondary-slide');
          } else {
            $slide.hide().removeClass('starting-slide').addClass('secondary-slide');
          }
        });
      };

      var bindThumbClicks = function () {
        if (typeof jQuery === 'undefined') return;
        if (document.documentElement.dataset.scThumbClickBound) return;
        document.documentElement.dataset.scThumbClickBound = 'true';

        jQuery(document).on('click.scPdpThumbs', '.product__thumbs.sc-pdp__thumbs--all .product__thumb-item', function (e) {
          if (this.closest('.product__thumbs') && this.closest('.product__thumbs').dataset.scThumbDragged === 'true') {
            this.closest('.product__thumbs').dataset.scThumbDragged = 'false';
            return;
          }

          var item = this;
          var index = parseInt(item.getAttribute('data-index'), 10);
          if (isNaN(index)) return;

          var thumbStrip = item.closest('.product__thumbs[id^="ProductThumbs-"]');
          if (!thumbStrip) return;

          var sectionId = thumbStrip.id.replace('ProductThumbs-', '');
          var $main = jQuery('#ProductPhotos-' + sectionId);

          e.preventDefault();
          switchMainImage($main, index);
          syncActiveThumb($main, index);
        });
      };

      var flattenThumbs = function () {
        if (typeof jQuery === 'undefined') return;

        jQuery('.product__photos').each(function () {
          jQuery(this)
            .removeClass('product__photos--beside')
            .addClass('product__photos--below sc-pdp-gallery sc-pdp__photos');
        });

        jQuery('.product__thumbs[id^="ProductThumbs-"]').each(function () {
          var $thumbs = jQuery(this);
          if ($thumbs.hasClass('slick-initialized')) {
            $thumbs.slick('unslick');
          }
          $thumbs
            .removeClass('product__thumbs--beside')
            .addClass('product__thumbs--below sc-pdp__thumbs--all')
            .attr('data-position', 'below')
            .css({
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'nowrap',
              maxWidth: '100%',
              width: '100%',
              minWidth: 0,
              marginLeft: 0,
              overflowX: 'auto',
              overflowY: 'hidden'
            });

          $thumbs.find('.slick-list, .slick-track').each(function () {
            this.removeAttribute('style');
          });
        });

        jQuery('.product__main-photos [id^="ProductPhotos-"].slick-initialized').each(function () {
          jQuery(this).slick('slickSetOption', 'asNavFor', null, true);
        });
      };

      var bindThumbDragScroll = function () {
        document.querySelectorAll('.product__thumbs.sc-pdp__thumbs--all').forEach(function (strip) {
          if (strip.dataset.scThumbDragBound) return;
          strip.dataset.scThumbDragBound = 'true';

          var isDown = false;
          var didDrag = false;
          var startPageX = 0;
          var scrollLeft = 0;

          strip.addEventListener('mousedown', function (e) {
            if (e.button !== 0 || e.target.closest('.product__thumb-item')) return;
            isDown = true;
            didDrag = false;
            strip.dataset.scThumbDragged = 'false';
            strip.classList.add('is-dragging');
            startPageX = e.pageX;
            scrollLeft = strip.scrollLeft;
          });

          strip.addEventListener('mouseleave', function () {
            isDown = false;
            strip.classList.remove('is-dragging');
          });

          strip.addEventListener('mouseup', function () {
            if (didDrag) {
              strip.dataset.scThumbDragged = 'true';
            }
            isDown = false;
            strip.classList.remove('is-dragging');
          });

          strip.addEventListener('mousemove', function (e) {
            if (!isDown) return;
            var dx = e.pageX - startPageX;
            if (Math.abs(dx) > 4) {
              didDrag = true;
              e.preventDefault();
              strip.scrollLeft = scrollLeft - dx;
            }
          });
        });
      };

      var refreshSliders = function () {
        if (typeof jQuery === 'undefined') return;

        jQuery('.product__main-photos [id^="ProductPhotos-"].slick-initialized').each(function () {
          jQuery(this).slick('setPosition');
        });
      };

      var postInit = function () {
        unveilImages();
        flattenThumbs();
        bindThumbDragScroll();
        refreshSliders();

        if (typeof jQuery !== 'undefined') {
          jQuery('.product__main-photos [id^="ProductPhotos-"].slick-initialized').each(function () {
            var $main = jQuery(this);
            syncActiveThumb($main, $main.slick('slickCurrentSlide'));
          });
        }
      };

      bindThumbClicks();

      if (typeof jQuery !== 'undefined') {
        jQuery(document).on('init', '.product__thumbs.sc-pdp__thumbs--all', function () {
          flattenThumbs();
        });

        jQuery(document).on('afterChange', '.product__main-photos [id^="ProductPhotos-"]', function (event, slick, currentSlide) {
          var $main = jQuery(this);
          syncActiveThumb($main, currentSlide);
          var slide = slick.$slides.get(currentSlide);
          if (slide) unveilImages(slide);
        });

        jQuery(document).on('beforeChange', '.product__main-photos [id^="ProductPhotos-"]', function (event, slick, currentSlide, nextSlide) {
          var slide = slick.$slides.get(nextSlide);
          if (slide) unveilImages(slide);
        });
      }

      window.addEventListener('load', postInit);
      setTimeout(postInit, 600);
      setTimeout(postInit, 1500);
      setTimeout(postInit, 3000);
      window.addEventListener('resize', function () {
        flattenThumbs();
        refreshSliders();
      });

      if (typeof jQuery !== 'undefined') {
        jQuery('body').on('matchSmall matchLarge', function () {
          setTimeout(function () {
            flattenThumbs();
            refreshSliders();
          }, 150);
        });
      }
    },

    initPDPSizeChart: function () {
      document.querySelectorAll('[data-sc-size-chart]').forEach(function (chart) {
        var form = chart.closest('form');
        if (!form) return;

        var sizeFromValue = function (value) {
          var base = (value || '').split(' - ')[0].trim().toLowerCase();
          var map = {
            small: 'small',
            medium: 'medium',
            large: 'large',
            'x-large': 'x-large',
            xlarge: 'x-large'
          };
          return map[base] || base.replace(/\s+/g, '-');
        };

        var sync = function () {
          var value = '';
          var sizeField = form.querySelector('fieldset[name="Size"] input:checked')
            || form.querySelector('select[data-index="option1"]')
            || form.querySelector('select[name="Size"]');

          if (sizeField) {
            value = (sizeField.value || '').trim();
          }

          var key = sizeFromValue(value);
          chart.querySelectorAll('.sc-pdp-size-chart__item').forEach(function (item) {
            var active = item.getAttribute('data-size') === key;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        };

        chart.querySelectorAll('.sc-pdp-size-chart__item').forEach(function (item) {
          item.addEventListener('click', function () {
            var targetValue = item.getAttribute('data-value');
            var inputs = form.querySelectorAll('fieldset[name="Size"] input');
            var input = null;
            inputs.forEach(function (candidate) {
              if (candidate.value === targetValue) {
                input = candidate;
              }
            });
            if (!input) return;
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            sync();
          });
        });

        form.addEventListener('change', sync);
        sync();
      });
    },

    initSmoothScroll: function () {
      document.querySelectorAll('a[href^="#sc-"]').forEach(function (link) {
        if (link.dataset.scBound) return;
        link.dataset.scBound = 'true';
        link.addEventListener('click', function (e) {
          var target = document.querySelector(link.getAttribute('href'));
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
    },

    initScrollTop: function () {
      var btn = document.getElementById('sc-scroll-top');
      if (!btn || btn.dataset.scBound) return;
      btn.dataset.scBound = 'true';

      var toggle = function () {
        btn.classList.toggle('is-visible', window.scrollY > 400);
      };

      btn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });

      window.addEventListener('scroll', toggle, { passive: true });
      toggle();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { SC.init(); });
  } else {
    SC.init();
  }

  document.addEventListener('shopify:section:load', function () { SC.init(); });
})();
